export enum ProdQualDegradPopup {
  Without = 0,
  Introducing = 1,
  With = 2,
  HowWorks = 3,
  Architecture = 4,
}
